import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInfo = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 17,
	height: 17,
	viewBox: "0 0 17 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M8.93719 14.7806C12.6334 14.7806 15.6297 11.7958 15.6297 8.11393C15.6297 4.43203 12.6334 1.44727 8.93719 1.44727C5.24099 1.44727 2.24463 4.43203 2.24463 8.11393C2.24463 11.7958 5.24099 14.7806 8.93719 14.7806Z",
					fill: "#F2F4F6",
					stroke: "#00819D",
					strokeWidth: 1.5,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M8.9375 10.7809V8.11426",
					stroke: "#00819D",
					strokeWidth: 1.5,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M8.9375 5.44727H8.94417",
					stroke: "#00819D",
					strokeWidth: 1.5,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0",
			children: /* @__PURE__ */ _jsx("rect", {
				x: .90625,
				y: .114258,
				width: 16.0621,
				height: 16,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgInfo);
export { ForwardRef as ReactComponent };
